import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    allUserBatchsLoading: false,
    allUserBatchesSuccess: {},
    allUserBatchsError: '',

    createUserBatchLoading: false,
    createUserBatchSuccess: {},
    createUserBatchError: '',

    getUserBatchDetailsLoading: false,
    getUserBatchDetailsSuccess: null,
    getUserBatchDetailsError: '',

    allMentorBatchsLoading: false,
    allMentorBatchesSuccess: {},
    allMentorBatchsError: '',

    createMentorBatchLoading: false,
    createMentorBatchSuccess: {},
    createMentorBatchError: '',

    getMentorBatchDetailsLoading: false,
    getMentorBatchDetailsSuccess: null,
    getMentorBatchDetailsError: '',

    allMentorTeacherLoading: false,
    allMentorTeacherSuccess: {},
    allMentorTeacherError: '',

    createMentorTeacherLoading: false,
    createMentorTeacherSuccess: {},
    createMentorTeacherError: '',

    getMentorTeacherDetailsLoading: false,
    getMentorTeacherDetailsSuccess: null,
    getMentorTeacherDetailsError: '',
}

export const userBatchSlice = createSlice({
    name: 'userBatch',
    initialState,
    reducers: {

        setAllUserBatchesLoading: (state, action) => {
            state.allUserBatchsLoading = true;
            state.allUserBatchesSuccess = null;
            state.allUserBatchsError = '';
        },
        setAllUserBatchesSuccess: (state, action) => {
            state.allUserBatchsLoading = false;
            state.allUserBatchesSuccess = action.payload;
            state.allUserBatchsError = '';
        },
        setAllUserBatchesError: (state, action) => {
            state.allUserBatchsLoading = false;
            state.allUserBatchesSuccess = null;
            state.allUserBatchsError = action.payload;
        },
        setCreateUserBatchLoading: (state) => {
            state.createUserBatchLoading = true;
            state.createUserBatchSuccess = {};
            state.createUserBatchError = '';
        },
        setCreateUserBatchSuccess: (state, action) => {
            state.createUserBatchLoading = false;
            state.createUserBatchSuccess = action.payload;
            state.createUserBatchError = '';
        },
        setCreateUserBatchError: (state, action) => {
            state.createUserBatchLoading = false;
            state.createUserBatchSuccess = {};
            state.createUserBatchError = action.payload;
        },
        setGetUserBatchDetailsLoading: (state) => {
            state.getUserBatchDetailsLoading = true;
            state.getUserBatchDetailsSuccess = {};
            state.getUserBatchDetailsError = '';
        },
        setGetUserBatchDetailsSuccess: (state, action) => {
            state.getUserBatchDetailsLoading = false;
            state.getUserBatchDetailsSuccess = action.payload;
            state.getUserBatchDetailsError = '';
        },
        setGetUserBatchDetailsError: (state, action) => {
            state.getUserBatchDetailsLoading = false;
            state.getUserBatchDetailsSuccess = {};
            state.getUserBatchDetailsError = action.payload;
        },
        setAllMentorTeacheresLoading: (state, action) => {
            state.allMentorTeacherLoading = true;
            state.allMentorTeacherSuccess = null;
            state.allMentorTeacherError = '';
        },
        setAllMentorTeacheresSuccess: (state, action) => {
            state.allMentorTeacherLoading = false;
            state.allMentorTeacherSuccess = action.payload;
            state.allMentorTeacherError = '';
        },
        setAllMentorTeacheresError: (state, action) => {
            state.allMentorTeacherLoading = false;
            state.allMentorTeacherSuccess = null;
            state.allMentorTeacherError = action.payload;
        },
        setCreateMentorTeacherLoading: (state) => {
            state.createMentorTeacherLoading = true;
            state.createMentorTeacherSuccess = {};
            state.createMentorTeacherError = '';
        },
        setCreateMentorTeacherSuccess: (state, action) => {
            state.createMentorTeacherLoading = false;
            state.createMentorTeacherSuccess = action.payload;
            state.createMentorTeacherError = '';
        },
        setCreateMentorTeacherError: (state, action) => {
            state.createMentorTeacherLoading = false;
            state.createMentorTeacherSuccess = {};
            state.createMentorTeacherError = action.payload;
        },
        setMentorTeacherDetailsLoading: (state) => {
            state.getMentorTeacherDetailsLoading = true;
            state.getMentorTeacherDetailsSuccess = {};
            state.getMentorTeacherDetailsError = '';
        },
        setMentorTeacherDetailsSuccess: (state, action) => {
            state.getMentorTeacherDetailsLoading = false;
            state.getMentorTeacherDetailsSuccess = action.payload;
            state.getMentorTeacherDetailsError = '';
        },
        setMentorTeacherDetailsError: (state, action) => {
            state.getMentorTeacherDetailsLoading = false;
            state.getMentorTeacherDetailsSuccess = {};
            state.getMentorTeacherDetailsError = action.payload;
        },

        setAllFacultyLoading: (state, action) => {
            state.allFacultyLoading = true;
            state.allFacultySuccess = null;
            state.allFacultyError = '';
        },
        setAllFacultySuccess: (state, action) => {
            state.allFacultyLoading = false;
            state.allFacultySuccess = action.payload;
            state.allFacultyError = '';
        },
        setAllFacultyError: (state, action) => {
            state.allFacultyLoading = false;
            state.allFacultySuccess = null;
            state.allFacultyError = action.payload;
        },
        setAllMentorBatchsLoading: (state, action) => {
            state.allMentorBatchsLoading = true;
            state.allMentorBatchesSuccess = null;
            state.allMentorBatchsError = '';
        },
        setAllMentorBatchsSuccess: (state, action) => {
            state.allMentorBatchsLoading = false;
            state.allMentorBatchesSuccess = action.payload;
            state.allMentorBatchsError = '';
        },
        setAllMentorBatchsError: (state, action) => {
            state.allMentorBatchsLoading = false;
            state.allMentorBatchesSuccess = null;
            state.allMentorBatchsError = action.payload;
        },
        setCreateMentorBatchLoading: (state) => {
            state.createMentorBatchLoading = true;
            state.createMentorBatchSuccess = {};
            state.createMentorBatchError = '';
        },
        setCreateMentorBatchSuccess: (state, action) => {
            state.createMentorBatchLoading = false;
            state.createMentorBatchSuccess = action.payload;
            state.createMentorBatchError = '';
        },
        setCreateMentorBatchError: (state, action) => {
            state.createMentorBatchLoading = false;
            state.createMentorBatchSuccess = {};
            state.createMentorBatchError = action.payload;
        },
        setMentorBatchDetailsLoading: (state) => {
            state.getMentorBatchDetailsLoading = true;
            state.getMentorBatchDetailsSuccess = {};
            state.getMentorBatchDetailsError = '';
        },
        setMentorBatchDetailsSuccess: (state, action) => {
            state.getMentorBatchDetailsLoading = false;
            state.getMentorBatchDetailsSuccess = action.payload;
            state.getMentorBatchDetailsError = '';
        },
        setMentorBatchDetailsError: (state, action) => {
            state.getMentorBatchDetailsLoading = false;
            state.getMentorBatchDetailsSuccess = {};
            state.getMentorBatchDetailsError = action.payload;
        },
        resetDetails: (state) => {
            state.createUserBatchSuccess = {};
            state.getUserBatchDetailsSuccess = {};
        },
        resetMentorDetails: (state) => {
            state.createMentorTeacherSuccess = {};
            state.getMentorTeacherDetailsSuccess = {};
        },
        resetMentorBatchDetails: (state) => {
            state.createMentorBatchSuccess = {};
            state.getMentorBatchDetailsSuccess = {};
        },
    }
})

export const {
    setGetUserBatchDetailsLoading, setGetUserBatchDetailsSuccess, setGetUserBatchDetailsError,
    setAllUserBatchesLoading,
    setAllUserBatchesSuccess,
    setAllUserBatchesError,
    setCreateUserBatchLoading,
    setCreateUserBatchSuccess,
    setCreateUserBatchError,
    setAllMentorTeacheresLoading, setAllMentorTeacheresSuccess, setAllMentorTeacheresError,
    setCreateMentorTeacherLoading,
    setCreateMentorTeacherSuccess,
    setCreateMentorTeacherError,
    setMentorTeacherDetailsLoading,
    setMentorTeacherDetailsSuccess,
    setMentorTeacherDetailsError,
    setAllMentorBatchsLoading, setAllMentorBatchsSuccess, setAllMentorBatchsError,
    setMentorBatchDetailsLoading, setMentorBatchDetailsSuccess, setMentorBatchDetailsError,
    setCreateMentorBatchLoading, setCreateMentorBatchSuccess, setCreateMentorBatchError,
    resetDetails,
    resetMentorDetails,
    resetMentorBatchDetails
} = userBatchSlice.actions;


export default userBatchSlice.reducer;